
export type UpdateNotificationSettings200TypeSettings = {[key: string]: boolean};
